import { AbortedError } from 'src/common/api/extended-emerald-error';
import { showEmeraldSelectionDialog } from 'src/common/components/interactive-dialogue/components/selection-dialogue/selection-dialog';
import { SelectListItem } from 'src/common/components/select-list/select-list';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { LineItemAddDto } from 'src/items-list/business-logic/service/interfaces/line-item-add.dto';
import { IItemLookup } from '../../common/interfaces/dtos/IItemLookup';
import { sellLinkedItem } from '../../linked-item/sell-linked-item';
import { closeAllItems } from 'src/all-items/all-items';
import { closeSearchModal } from 'src/search/search';

export const handleWarrantyItems = async (
  lineItem: LineItemAddDto,
  itemLookup: IItemLookup,
  linkedItems: IItemLookup[],
): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const modalId = 'WARRANTY_SELECTION';
    const noneIdAndLocale = 'None';

    const selectionList: SelectListItem[] = [
      { id: noneIdAndLocale, description: noneIdAndLocale, price: '' },
      ...linkedItems
        .filter(item => item.regularSalesUnitPrice)
        .map((item: IItemLookup) => ({
          id: item.itemId || '',
          description: item.description,
          price: item.unitPrice
            ? convertCurrency(item.unitPrice || 0, item.regularSalesUnitPrice?.price.currency)
            : 'FREE',
        })),
    ];

    const onCancel = (): void => {
      popEmeraldModal(modalId);
      reject(new AbortedError());
    };

    const onAccept = async (itemId: string): Promise<void> => {
      const item = linkedItems.find(linkedItem => linkedItem.itemId === itemId);

      closeAllItems();
      closeSearchModal();
      popEmeraldModal(modalId);

      return sellLinkedItem(lineItem, itemLookup, item)
        .then(resolve)
        .catch(reject);
    };

    showEmeraldSelectionDialog(
      {
        selectListItems: selectionList || [],
        message: 'SelectWarranty',
        onCancel,
        onAccept,
        dataTestId: 'warranty-items-modal',
      },
      modalId,
    );
  });
};
